import { useEffect, useState } from "react";
import { http } from "../api";
import { HandCoins } from "lucide-react";
import { Modal, PageHeader, AddButton, FormRow, EmptyState } from "../shared";

const empty = { text: "", made_by: "", target_date: "", ward: 7, budget: 0, status: "Initiated" };
const statuses = ["Initiated", "In Progress", "Fulfilled", "Delayed", "Broken"];
function tone(s) { return { Initiated: "amber", "In Progress": "blue", Fulfilled: "green", Delayed: "red", Broken: "red" }[s] || "blue"; }

export default function Promises() {
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const load = () => http.get("/promises").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try { await http.post("/promises", { ...form, ward: Number(form.ward), budget: Number(form.budget) }); setShow(false); setForm(empty); load(); }
    finally { setSaving(false); }
  };

  return (
    <>
      <PageHeader eyebrow="POLITICAL COMMITMENTS" title="Promises" subtitle={`${rows.length} tracked commitments`}
        actions={<AddButton onClick={() => setShow(true)} label="Add promise" testid="promises-add-button" />} />

      <section className="panel">
        {rows.length === 0 ? <EmptyState icon={HandCoins} title="No promises" hint="Track a public promise here." /> : (
          <div className="promise-list">
            {rows.map((p, i) => (
              <div key={p.promise_id} className="promise-row" data-testid={`promise-row-${i}`}>
                <div className="p-left">
                  <b>{p.text}</b>
                  <small>By {p.made_by} · Target {p.target_date || "TBD"} · ₹{Number(p.budget || 0).toLocaleString("en-IN")}</small>
                </div>
                <span className={`chip ${tone(p.status)}`}>{p.status}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      {show && (
        <Modal title="Add promise" onClose={() => setShow(false)} testid="promise-modal">
          <FormRow label="Promise text"><input data-testid="form-text-input" value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} /></FormRow>
          <div className="form-grid">
            <FormRow label="Made by"><input data-testid="form-madeby-input" value={form.made_by} onChange={(e) => setForm({ ...form, made_by: e.target.value })} /></FormRow>
            <FormRow label="Target date"><input data-testid="form-target-input" type="date" value={form.target_date} onChange={(e) => setForm({ ...form, target_date: e.target.value })} /></FormRow>
            <FormRow label="Budget (₹)"><input data-testid="form-budget-input" type="number" value={form.budget} onChange={(e) => setForm({ ...form, budget: e.target.value })} /></FormRow>
            <FormRow label="Status"><select data-testid="form-status-input" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>{statuses.map((s) => <option key={s}>{s}</option>)}</select></FormRow>
          </div>
          <div className="form-actions">
            <button className="outline" data-testid="form-cancel-button" onClick={() => setShow(false)}>Cancel</button>
            <button className="primary" data-testid="form-save-button" disabled={saving || !form.text} onClick={save}>{saving ? "Saving…" : "Save"}</button>
          </div>
        </Modal>
      )}
    </>
  );
}
